import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import IndividualReports from "@/test-data/IndividualReports";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { NewMedicalTextDialog } from "./NewMedicalTextDialog";
import PatientEncounters from "./PatientEncounters";

export default function TestData() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [focusedMedicalTextId, setFocusedMedicalTextId] = useState<string | null>(null);
  const [isMedicalTextDialogOpen, setIsMedicalTextDialogOpen] = useState(false);

  // Get the active tab from URL params, defaulting to 'individual'
  const urlTab = searchParams.get("tab") as "individual" | "encounter" | null;
  const [activeTab, setActiveTab] = useState<"individual" | "encounter">(urlTab || "individual");

  // Update URL when activeTab changes
  useEffect(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("tab", activeTab);
      return newParams;
    });
  }, [activeTab, setSearchParams]);

  // Update local state when URL changes (for browser back/forward)
  useEffect(() => {
    if (urlTab && (urlTab === "individual" || urlTab === "encounter")) {
      setActiveTab(urlTab);
    }
  }, [urlTab]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Test Data</h1>
          <p className="text-muted-foreground">Manage and view test medical text examples for classification.</p>
        </div>
        <Button onClick={() => setIsMedicalTextDialogOpen(true)}>Add Test Data</Button>
        {isMedicalTextDialogOpen && (
          <NewMedicalTextDialog
            open={isMedicalTextDialogOpen}
            onClose={() => {
              setIsMedicalTextDialogOpen(false);
              setFocusedMedicalTextId(null);
            }}
            medicalTextId={focusedMedicalTextId ?? undefined}
          />
        )}
      </div>
      <div className="mb-4">
        <Tabs value={activeTab} onValueChange={(value) => setActiveTab(value as "individual" | "encounter")}>
          <TabsList>
            <TabsTrigger value="individual">Individual Reports</TabsTrigger>
            <TabsTrigger value="encounter">Patient Encounters</TabsTrigger>
          </TabsList>
          <TabsContent value="individual">
            <IndividualReports />
          </TabsContent>
          <TabsContent value="encounter">
            <PatientEncounters />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
